var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconDone = function SvgIconDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    color: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93038 3.76212L4.94091 8.92792C4.89672 8.97405 4.83657 9 4.77381 9C4.71106 9 4.65091 8.97405 4.60671 8.92792L2.06962 6.30116C2.02506 6.25541 2 6.19313 2 6.12816C2 6.06318 2.02506 6.0009 2.06962 5.95515L2.39911 5.61401C2.4433 5.56788 2.50346 5.54193 2.56621 5.54193C2.62896 5.54193 2.68912 5.56788 2.73331 5.61401L4.77146 7.72419L9.26669 3.0701C9.3598 2.97663 9.50778 2.97663 9.60089 3.0701L9.93038 3.41611C9.97494 3.46186 10 3.52414 10 3.58911C10 3.65409 9.97494 3.71637 9.93038 3.76212Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconDone.e56193d7.svg";
export { ForwardRef as ReactComponent };